import { memo } from "react";

import type { QueryData } from "../../../model";

type Props = {
	questionAndAnswerList: QueryData["questionAndAnswerList"];
};

export const ListOfQuestionAndAnswerCompositions = memo(({ questionAndAnswerList }: Props) => {
	return (
		<div className="space-y-5">
			{questionAndAnswerList.map(({ question, answer }, index) => {
				const questionText = `Q. ${question}`;
				const answerText = `A. ${answer.join("、")}`;
				return (
					<div key={index} className="whitespace-pre-wrap text-xs sm:text-sm lg:text-sm">
						<p className="mb-2">{questionText}</p>
						<p>{answerText}</p>
					</div>
				);
			})}
		</div>
	);
});
